import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', _vm._g(_vm._b({
    staticClass: "v-otp-input"
  }, 'div', _vm.$attrs, false), _vm.$listeners), _vm._l(+_vm.length, function (i) {
    var _obj;
    return _c('Input', {
      key: i,
      ref: "inputs",
      refInFor: true,
      class: (_obj = {}, _obj["v-otp-input--" + (i - 1)] = true, _obj),
      attrs: {
        "autocomplete": "one-time-code",
        "disabled": _vm.disabled,
        "readonly": _vm.readonly,
        "type": _vm.type,
        "value": _vm.otp[i - 1],
        "min": _vm.type === 'number' ? 0 : null,
        "step": _vm.type === 'number' ? '1' : null,
        "placeholder": _vm.placeholderInternal[i - 1],
        "pattern": _vm.type === 'number' ? '[0-9]*' : null,
        "input-listeners": {
          input: function (e) {
            return _vm.handleInput(e, i - 1);
          }
        }
      },
      on: {
        "blur": _vm.handleBlur,
        "focus": function ($event) {
          return _vm.handleFocus($event, i - 1);
        },
        "keydown": _vm.handleKeyDown,
        "keyup": function ($event) {
          return _vm.handleKeyUp($event, i - 1);
        }
      }
    });
  }), 1);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-287c86b0_0", {
    source: ".v-otp-input[data-v-287c86b0]{display:inline-flex;gap:.5rem}.v-otp-input[data-v-287c86b0] .v-input{border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min));height:4rem;padding:0;width:3rem;font-size:1.25rem}.v-otp-input[data-v-287c86b0] .v-input input{text-align:center}.v-otp-input[data-v-287c86b0] .v-input input[type=number]{-moz-appearance:textfield}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-287c86b0";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var OtpInput = __vue_component__;
export { OtpInput as default };